import React from "react";

import Button from "component/Button/Button";
import "./home.scss";
import FadeUp from "component/FadeUp/FadeUp";
import useScreenMobile from "hooks/useScreenMobile";

import { analytics } from "../../firebase";
import { logEvent } from "firebase/analytics";

const Overlays = () => {
  const isMobile = useScreenMobile({ size: 678 });

  return (
    <section className="container overlay">
      <div className="overlayContainer">
        <div className="wrapper">
          {/* <p className="amount">₹ 14,999</p> */}
          <FadeUp>
            <p className="intro" style={{ fontWeight: "300" }}>
              Offer price of {isMobile && <br />}
              {isMobile && <span className="strikedAmount">₹ 15,999</span>}{" "}
              <span className="introAmount">₹ 11,999</span>
              {isMobile && <br />} for limited period
            </p>
          </FadeUp>
          <Button
            title="Order Now"
            onClick={() => {
              logEvent(analytics, "order_now_overlays");
              window.location.href = "https://shop.neosapien.xyz/";
            }}
            fontsize={isMobile ? "16px" : "20px"}
            padding={isMobile ? "16px 24px " : "15px 30px"}
          />
        </div>
      </div>
    </section>
  );
};

export default Overlays;
